const shuffle = (arr) => [...arr].sort(() => 0.5 - Math.random());

/**
 * Construit des questions de quiz vocabulaire à partir d'une liste de mots.
 * Seule fonction qui construit un QCM de vocabulaire — utilisée par
 * VocabQuizSession (mode choisi par l'utilisateur) et par le Daily Plan
 * (mode pré-défini), pour ne jamais diverger de l'affichage riche
 * (traduction, translittération, indice WordCard).
 *
 * `mode` : "ar-fr" | "fr-ar" | "mixed"
 * `wideDistractorPool` : pool large de mots pour tirer des distracteurs
 * plausibles (peut être plus grand que `words` lui-même).
 */
export function buildVocabQuestions(words, mode, wideDistractorPool) {
  // Fallback to 'words' if wideDistractorPool is undefined or null
  const pool = wideDistractorPool || words;

  return words.map((w) => {
    const isArToFr = mode === "mixed" ? Math.random() > 0.5 : mode === "ar-fr";
    const ans = isArToFr ? w.translation_en : w.word_ar;
    const ansTranslation = isArToFr ? w.word_ar : w.translation_en;

    // Safely filter on the guaranteed array
    const distractorWords = shuffle(pool.filter((x) => x.id !== w.id)).slice(
      0,
      3,
    );

    const pairs = shuffle([
      {
        display: ans,
        translation: ansTranslation,
        // Phonétique de l'option, seulement quand l'option EST le mot
        // arabe (donc quand le prompt est en français).
        latin: isArToFr ? "" : w.word_latin || "",
      },
      ...distractorWords.map((x) => ({
        display: isArToFr ? x.translation_en : x.word_ar,
        translation: isArToFr ? x.word_ar : x.translation_en,
        latin: isArToFr ? "" : x.word_latin || "",
      })),
    ]);

    const options = pairs.map((p) => p.display);

    return {
      prompt: isArToFr ? w.word_ar : w.translation_en,
      // Le prompt et les options sont arabes ou français question par
      // question (surtout en mode "mixte") — Quiz.jsx lit ces flags en
      // priorité sur les props globales arabicPrompt/arabicOptions.
      arabicPrompt: isArToFr,
      arabicOptions: !isArToFr,
      // Translittération du prompt, affichée sous le mot arabe quand le
      // prompt de CETTE question est en arabe.
      promptLatin: isArToFr ? w.word_latin || "" : "",
      options,
      optionTranslations: pairs.map((p) => p.translation),
      optionLatins: pairs.map((p) => p.latin),
      answer: options.indexOf(ans),
      skill: "vocabulary",
      key: w.id,
      ref: w.id,
    };
  });
}
